<ion-row class="align-items-center">
  <ion-col size="12" size-lg="8">
    <h5 class="form-section-title">
      <mat-icon>tune</mat-icon>
      <strong>Secciones y propiedades</strong>
    </h5>
  </ion-col>
</ion-row>


<div [formGroup]="propertyForm" class="property-block">
  <ion-grid>

    <!-- 1º Fila-->
    <ion-row>
      <ion-col size="12" size-lg="4">
        <mat-form-field appearance="fill">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="inputType" (selectionChange)="onInputTypeChange($event)">
            <mat-option *ngFor="let type of propertyTypes" [value]="type">
              {{ inputTypeLabels[type] }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>


      <ion-col size="12" size-lg="4">
        <mat-form-field appearance="fill" class="w-100" floatLabel="always">
          <mat-label>Incluir dentro de una sección</mat-label>
          <mat-select formControlName="parentId" placeholder="Selecciona una sección"
            (selectionChange)="onParentChange($event)">
            <mat-option *ngFor="let prop of properties" [value]="prop.id">
              {{ prop.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>


    </ion-row>

    <!-- Fila 2 -->
    <ion-row>
      <ion-col size="12" size-lg="4">
        <mat-form-field appearance="fill" floatLabel="always">
          <mat-label>Etiqueta visible</mat-label>
          <input matInput formControlName="label" placeholder="Ej: Nombre de la propiedad" />
        </mat-form-field>
      </ion-col>

      <!-- Campo dinámico segun TYPE -->
      <ion-col size="12" size-lg="4">

        <!-- TEXT -->
        <mat-form-field appearance="fill" floatLabel="always" *ngIf="propertyForm.get('inputType')?.value === 'text'">
          <mat-label>Valor por defecto</mat-label>
          <input matInput formControlName="value" placeholder="Escribe un valor" />
        </mat-form-field>

        <!-- NUMBER -->
        <mat-form-field appearance="fill" floatLabel="always" *ngIf="propertyForm.get('inputType')?.value === 'number'">
          <mat-label>Valor numérico</mat-label>
          <input matInput type="number" formControlName="value" />
        </mat-form-field>

        <!-- BOOLEAN -->
        <div *ngIf="propertyForm.get('inputType')?.value === 'boolean'" class="boolean-default">
          <mat-slide-toggle formControlName="value" color="primary">
            Sí / No
          </mat-slide-toggle>
        </div>

        <!-- LIST -->
        <mat-form-field appearance="fill" floatLabel="always" *ngIf="propertyForm.get('inputType')?.value === 'list'">
          <mat-label>Valor por defecto</mat-label>
          <mat-select formControlName="value">
            <mat-option *ngFor="let opt of options.controls" [value]="opt.value.value">
              {{ opt.value.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- DATE -->
        <mat-form-field appearance="fill" floatLabel="always" *ngIf="propertyForm.get('inputType')?.value === 'date'">
          <mat-label>Fecha</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="value" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>


      </ion-col>



      <ion-col size="12" size-lg="4"
        *ngIf="propertyForm.get('inputType')?.value === 'text' || propertyForm.get('inputType')?.value === 'number'">
        <mat-form-field appearance="fill" floatLabel="always">
          <mat-label>Unidad (opcional)</mat-label>
          <input matInput formControlName="unit" placeholder="Ej: cm, %..." />
        </mat-form-field>
      </ion-col>
    </ion-row>


    <ion-col size="12" size-lg="4" class="align-center" *ngIf="propertyForm.get('inputType')?.value !== 'section'">
      <mat-slide-toggle formControlName="isRequired" color="primary">
        Campo obligatorio
      </mat-slide-toggle>
    </ion-col>



    <!-- Opciones solo si LIST -->
    <div *ngIf="propertyForm.get('inputType')?.value === 'list'" class="mt-3">
      <ion-row>
        <ion-col size="12" size-lg="4">
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Añadir opción</mat-label>
            <input matInput #optionInput placeholder="Escribe una opción" />
            <button mat-icon-button matSuffix color="primary"
              (click)="addOption(optionInput.value); optionInput.value = '';">
              <mat-icon>add</mat-icon>
            </button>
          </mat-form-field>
        </ion-col>
        <ion-col size="12" size-lg="4" class="add-button-wrapper">
          <button mat-raised-button color="primary" (click)="addOption(optionInput.value); optionInput.value = '';">
            <mat-icon>add</mat-icon> Añadir opción
          </button>
        </ion-col>
      </ion-row>

      <div class="options-list">
        <div class="option-chip" *ngFor="let opt of options.controls; let i = index;">
          <span>{{ opt?.value?.value }}</span>
          <button mat-icon-button color="warn" (click)="deleteOption(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <small>Puedes añadir tantas opciones como necesites.</small>
    </div>


  </ion-grid>
</div>

<div class="buttons-row">

  <button *ngIf="editingProperty" mat-raised-button color="accent" (click)="resetForm()">

    <mat-icon>cancel</mat-icon>
    Cancelar
  </button>




  <!-- Botón de guardar -->
  <button mat-raised-button color="primary" (click)="save()" class="add-property-btn">
    <mat-icon>{{ editingProperty ? 'edit_note' : 'add' }}</mat-icon>
    {{ editingProperty ? 'Guardar cambios' : 'Añadir propiedad' }}
  </button>

</div>
